import { Color, Spacing } from 'zens-storybook'
import { observer } from 'mobx-react-lite'
import { View, StyleSheet, ViewProps } from 'react-native'

import TestResult from './result'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.refinedGreen,
    paddingBottom: Spacing.S,
  },
})
interface Props extends ViewProps {}

const TestComplete = (props: Props) => {
  const { children, style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <TestResult />
      {children}
    </View>
  )
}

export default observer(TestComplete)
